import React, { type ReactNode } from "react"
import { Img, Box, useMediaQuery, type ChakraProps } from "@chakra-ui/react"
import { whiteFireOnlyImg, whiteFireRightImg } from "../images"
import { getLandscapeOrPortraitValues } from "./utils"
import { Colors } from "../../theme/colors"
import snapLogo from "../../assets/images/SnapLogoSignup.png"

type firePosType = "left" | "right"
interface ModalThreeRowLayoutInterface {
  firePos?: firePosType
  middleComponent: ReactNode
  footerComponent: ReactNode
  footerProps?: ChakraProps
  middleProps?: ChakraProps
}
export const ModalThreeRowLayout = ({
  middleComponent,
  footerComponent,
  footerProps,
  middleProps,
  firePos = "left"
}: ModalThreeRowLayoutInterface): JSX.Element => {
  const getBGImage = (pos: firePosType): string => {
    if (pos === "left") {
      return `${Colors.Primary.c1} url(${whiteFireOnlyImg}) no-repeat 0 0`
    }
    return `${Colors.Primary.c1} url(${whiteFireRightImg}) no-repeat 100% 0`
  }

  const [isLargerThan800] = useMediaQuery("(min-width: 815px)")
  const [isLandscape] = useMediaQuery("(orientation: landscape)")

  return (
    <Box
      margin="auto"
      bg={getBGImage(firePos)}
      backgroundSize={"contain"}
      backgroundImage={["none", "none", "none", "none", firePos === "left" ? whiteFireOnlyImg : whiteFireRightImg]}
      boxSizing="border-box"
      height="calc(100svh -  env(safe-area-inset-bottom))"
      width={"calc(100% - env(safe-area-inset-left) * 2)"}
      display={"grid"}
      gridTemplateRows={"2fr 2fr 1fr"}
      gridTemplateColumns={["1fr minMax(240px, 550px) 1fr"]}
      p={getLandscapeOrPortraitValues("4", "2", !isLargerThan800 && isLandscape)}
      overflow={"auto"}
      rowGap={getLandscapeOrPortraitValues("32px", "12px", !isLargerThan800 && isLandscape)}
      textAlign={"center"}
    >
      <Box gridRowStart={1} gridRowEnd={2} gridColumnStart={2} gridColumnEnd={3} alignSelf={"center"}>
        <Img src={snapLogo} maxH="25vh" margin="auto" justifySelf={"center"} alt="Snap Fire Systems Logo" />
      </Box>
      <Box gridRowStart={2} gridRowEnd={3} gridColumnStart={2} gridColumnEnd={3} {...middleProps}>
        {middleComponent}
      </Box>
      <Box gridRowStart={3} gridRowEnd={4} gridColumnStart={2} gridColumnEnd={3} {...footerProps}>
        {footerComponent}
      </Box>
    </Box>
  )
}
